<template>
  <router-link to="/events/archives/list" class="banner" :class="{ isSide }">
    <img src="@/assets/images/icon/pc-person.svg" alt="" />
    <div class="textArea">
      <div class="text right-area">過去に配信された動画が閲覧可能！</div>
      <div class="title right-area">
        <span><span class="green">イベント・セミナー</span>アーカイブ</span>
      </div>
    </div>
  </router-link>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ArchiveBanner',
  props: {
    isSide: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;
.banner {
  border: solid 2px #36cbc2;
  border-radius: 8px;
  background-color: var.$color-white;
  max-width: 400px;
  height: 80px;
  margin-left: auto;
  margin-right: auto;
  padding: 16px 4px;

  display: flex;
  justify-content: center;
  align-items: center;
  img {
    margin-right: 8px;
    height: 70%;
  }
  @include mixins.media() {
    padding: 16px 24px;
    img {
      height: 100%;
    }
    &.isSide {
      position: relative;
      height: 98px;
      padding: 36px 12px 16px 16px;
      .text {
        position: absolute;
        left: 0;
        top: 8px;
        width: 100%;
        text-align: center;
      }
      .title {
        font-size: 16px;
      }
    }
  }
}
.text {
  font-size: 11px;
  @include mixins.media() {
    font-size: 11px;
  }
}
.title {
  font-size: 16px;
  @include mixins.media() {
    font-size: 19px;
  }
  vertical-align: bottom;
  .green {
    color: var.$color-main;
  }
}
.right-area {
  font-weight: bold;
  line-height: 22px;
  letter-spacing: 0;
}
</style>
